import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEventList } from "../../Redux/Actions/eventActions";
import { columnsEvents } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";

const ListEvents = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });


  const fetchDetails = useCallback(async (page, limit, showLoader = true) => {
    const eventData = {
      page,
      limit,
      is_deleted: false,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(getEventList(eventData, showLoader));

      if (!showLoader) {
        toast.success("kiosk list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh kiosk list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  )


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  const { events, loading } = useSelector((state) => state.events);



  useEffect(() => {
    if (events?.total) {
      setPagination((prevData) => ({ ...prevData, total: events.total }));
    }
  }, [events]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponent
        dataSource={(Array.isArray(events?.data) && events.data) || []}
        columns={columnsEvents}
        // filterFunction={filterHandler}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        h3heading="Events List"
        setState={setSearchQuery}
        buttonhead2="Add Event"
        navigateTo2="/event/add"
      ></TableComponent>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListEvents;
